const SESSION_PREFIX_RE = /^\s*session\s*\d+\s*[:\-|]?\s*/i

const TYPE_RULES = [
	{
		type: 'career_quiz',
		tokens: ['career quiz', 'personality review', 'career assessment quiz'],
	},
	{
		type: 'career_essay',
		tokens: ['career reflection essay', 'career essay'],
	},
	{
		type: 'country_exploration',
		tokens: ['country exploration'],
	},
	{
		type: 'university_exploration',
		tokens: ['university exploration'],
	},
	{
		type: 'pathway_alignment',
		tokens: ['masar selection alignment', 'pathway alignment'],
	},
	{
		type: 'profile_building',
		tokens: ['profile building'],
	},
	{
		type: 'class_presentation',
		tokens: ['class presentation'],
	},
	{
		type: 'LoR',
		tokens: ['letter of recommendation', 'recommendation letter', 'lor'],
	},
	{
		type: 'Essay',
		tokens: ['create essay', 'essay'],
	},
	{
		type: 'Document',
		tokens: ['document', 'documents', 'form completion', 'missing document upload'],
	},
	{
		type: 'Application',
		tokens: ['application'],
	},
]

export const normalizeTaskTitle = rawTitle => {
	const title = String(rawTitle || '').trim()
	if (!title) return ''
	return title.replace(SESSION_PREFIX_RE, '').replace(/\s+/g, ' ').trim()
}

const detectTypeByTitle = rawTitle => {
	const normalized = normalizeTaskTitle(rawTitle).toLowerCase()
	if (!normalized) return null
	const rule = TYPE_RULES.find(item =>
		item.tokens.some(token => normalized.includes(token)),
	)
	return rule?.type || null
}

export const resolveTaskType = ({
	type,
	title,
	fallback = 'General',
}) => {
	const explicit = String(type || '').trim()
	if (explicit && explicit.toLowerCase() !== 'general') {
		return explicit
	}
	return detectTypeByTitle(title) || fallback
}

